import styled from 'styled-components';

import Button from 'components/shared/Button';
import ButtonGroup from 'components/shared/ButtonGroup';
import { colors } from 'styles/theme/colors';

type Props = {
  label: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function CriteriaDeleteConfirm({ label, description, onConfirm, onCancel }: Props) {
  return (
    <DeleteContainer>
      <HeaderGroup>
        <DeleteTitle>Delete Criteria?</DeleteTitle>
        <DeleteMessage>
          Are you sure you wish to remove this criteria? Once removed, the criteria will no longer be considered as part
          of the Admissions summarization
        </DeleteMessage>
      </HeaderGroup>
      <Detail>
        <DetailLabel>Criteria:</DetailLabel>
        <DetailValue>{label}</DetailValue>
      </Detail>
      <Detail>
        <DetailLabel>Description:</DetailLabel>
        <DetailValue>{description}</DetailValue>
      </Detail>
      <StyledButtonGroup>
        <Button variant='ghost' onClick={onCancel}>
          Cancel
        </Button>
        <Button variant='danger' onClick={onConfirm}>
          Delete Criteria
        </Button>
      </StyledButtonGroup>
    </DeleteContainer>
  );
}

const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DeleteTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${colors.red100};
`;

const DeleteMessage = styled.div`
  font-size: 12px;
  line-height: 1.5;
`;

const Detail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DetailLabel = styled.div`
  font-weight: 500;
  font-size: 12px;
`;

const DetailValue = styled.div`
  font-size: 12px;
`;

const StyledButtonGroup = styled(ButtonGroup)`
  justify-content: flex-end;
`;
